export default "/images/smartbox-hover.svg?719bc24fe4b136a990be429f258ab265";